import { render, staticRenderFns } from "./navbar-container.vue?vue&type=template&id=0a3af4de&scoped=true"
import script from "./navbar-container.vue?vue&type=script&lang=js"
export * from "./navbar-container.vue?vue&type=script&lang=js"
import style0 from "./navbar-container.vue?vue&type=style&index=0&id=0a3af4de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3af4de",
  null
  
)

export default component.exports